module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": "/home"
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "head-user",
    attrs: {
      "to": "/main"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "product-banner"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "contact-us"
  }, [_c('div', {
    staticClass: "contact_top"
  }, [_c('div', {
    staticClass: "nav-links"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("关于我们")])], 1), _vm._v(" "), _c('li', [_vm._v("|")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("联系我们")])], 1), _vm._v(" "), _c('li', [_vm._v("|")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/pay"
    }
  }, [_vm._v("支付方式")])], 1), _vm._v(" "), _c('li', [_vm._v("|")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/agreement"
    }
  }, [_vm._v("服务条款")])], 1)])])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('c-footer', {
    attrs: {
      "status": "home"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product_title"
  }, [_c('h4', [_vm._v("联系我们")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "#f7f7f7",
      "padding": "0 0.2rem 0.5rem 0.2rem"
    }
  }, [_c('div', {
    staticClass: "agreement-content"
  }, [_c('div', {
    staticClass: "pay-package"
  }, [_c('div', {
    staticClass: "pay-package-title"
  }, [_c('div', {
    staticClass: "pay-title-text text-center clearfix"
  }, [_c('span', [_vm._v("支付方式")])]), _vm._v(" "), _c('div', {
    staticClass: "pay-subtitle-text"
  }, [_vm._v("\n            WeChat Pay\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "default-transition"
  }, [_c('div', {
    staticClass: "pkg-item-icon-wechat"
  }), _vm._v(" "), _c('p', [_vm._v("公众号名称：阿贝云")]), _vm._v(" "), _c('p', [_vm._v("账号主体：陕西云游四海网络科技有限公司")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "0.5rem"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pay-package"
  }, [_c('div', {
    staticClass: "pay-package-title"
  }, [_c('div', {
    staticClass: "pay-title-text text-center clearfix"
  }, [_c('span', [_vm._v("支付宝支付")])]), _vm._v(" "), _c('div', {
    staticClass: "pay-subtitle-text"
  }, [_vm._v("\n            use Alipay Pay\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "default-transition"
  }, [_c('div', {
    staticClass: "pkg-item-icon-alipay"
  }), _vm._v(" "), _c('p', [_vm._v("公众号名称：阿贝云")]), _vm._v(" "), _c('p', [_vm._v("账号主体：陕西云游四海网络科技有限公司")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "0.5rem"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pay-package"
  }, [_c('div', {
    staticClass: "pay-package-title"
  }, [_c('div', {
    staticClass: "pay-title-text text-center clearfix"
  }, [_c('span', [_vm._v("对公账户")])]), _vm._v(" "), _c('div', {
    staticClass: "pay-subtitle-text"
  }, [_vm._v("\n            Corporate Account\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "default-transition"
  }, [_c('div', {
    staticClass: "pkg-item-icon-zhujiwu"
  }), _vm._v(" "), _c('p', [_vm._v("开户行：中国交通银行陕西自贸试验区西安锦业路支行")]), _vm._v(" "), _c('p', [_vm._v("户  名：陕西云游四海网络科技有限公司")]), _vm._v(" "), _c('p', [_vm._v("帐  号：611301132018010127582")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact_bottom clearfix"
  }, [_c('a', {
    staticClass: "logo-bottom",
    attrs: {
      "href": "javascript:void(0)"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "weixin-b"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('a', {
    staticStyle: {
      "float": "right",
      "margin-right": "0.32rem"
    },
    attrs: {
      "href": "https://www.abeiyun.com"
    }
  }, [_vm._v("切换电脑版")])]), _vm._v(" "), _c('div', {
    staticClass: "contact_bottom_r"
  }, [_vm._v("\n          ©2018 abeiyun All rights reserved\n        ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-978f3510","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/pay.vue
// module id = efye
// module chunks = 1